import React from 'react';
import { FlowerIcon, ShieldCheckIcon, ZapIcon, LockIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
type PriceSectionProps = {
  onCTA: () => void;
};
const badges = [{
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ShieldCheckIcon,
  label: 'Una sola vez'
}];
export function PriceSection({
  onCTA
}: PriceSectionProps) {
  return <section id="precio" className="w-full scroll-mt-20 bg-crema py-20 sm:py-28" data-id="element-149" data-mp="30fgkiiytwfgb">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-150" data-mp="2qjn7yzl40lyj">
        <Reveal className="text-center" data-id="element-151" data-mp="2qketfhkzt3b3">
          <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-152" data-mp="2mi1nas2c33ds">
            Invierte en ti hoy
          </h2>
          <p className="mt-4 text-lg text-tinta/70" data-id="element-153" data-mp="or8rm4y7rpk8">
            Menos de lo que gastas en una salida, por 30 días que pueden cambiar
            cómo te sientes en tu cuerpo.
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-154" data-mp="1mhuf6731w1t4">
          <div className="mt-10 overflow-hidden rounded-[2rem] border border-nude bg-white p-8 text-center shadow-xl shadow-rosa/15 sm:p-12" data-id="element-155" data-mp="1mkoz7xi5jkm0">
            <span className="inline-flex items-center gap-2 rounded-full bg-rosa/15 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.18em] text-rosa-dark" data-id="element-156" data-mp="1difnx5f27n7k">
              <FlowerIcon className="h-3.5 w-3.5" strokeWidth={2} data-id="element-157" data-mp="1hllw4ilqfogo" />
              Oferta de lanzamiento
            </span>

            <div className="mt-6 flex flex-wrap items-end justify-center gap-x-3 gap-y-2" data-id="element-158" data-mp="2a7x62jv8b1q5">
              <span className="font-serif text-2xl text-tinta/40 line-through" data-id="element-159" data-mp="1wgrzsyxcvb6u">
                $47 USD
              </span>
              <span className="mb-1 rounded-full bg-rosa/15 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-rosa-dark" data-id="element-160" data-mp="20hlp9wqg4y1u">
                65% de descuento
              </span>
              <span className="font-serif text-6xl font-semibold text-rosa-dark sm:text-7xl" data-id="element-161" data-mp="2sz7umudhf2ev">
                $17
              </span>
              <span className="pb-2 text-lg font-medium text-tinta/60" data-id="element-162" data-mp="32u4xq51wcfn7">
                USD
              </span>
            </div>
            <p className="mt-2 text-sm text-tinta/60" data-id="element-163" data-mp="2yr8lqx6v3hs8">
              Un solo pago · Acceso de por vida
            </p>

            <CTAButton id="comenzar-transformacion" onClick={onCTA} icon={FlowerIcon} size="lg" className="mt-8 w-full sm:w-auto" data-id="element-164" data-mp="2ov5krunqxp6v">
              Comenzar mi transformación
            </CTAButton>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-tinta/70" data-id="element-165" data-mp="2f39all8dy8ma">
              {badges.map(b => <span key={b.label} className="inline-flex items-center gap-1.5" data-id="element-166" data-mp="265gwulibb910">
                  <b.icon className="h-4 w-4 text-dorado" strokeWidth={1.8} data-id="element-167" data-mp="217f9hodusnjq" />
                  {b.label}
                </span>)}
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}